import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { rememberEnhancer, rememberReducer } from 'redux-remember';

import { listenerMiddleware } from './listener';
import auth from './modules/auth/slice';
import bible from './modules/bible/slice';
import bootstrapper from './modules/bootstrapper/slice';
import output from './modules/output/slice';
import playlist from './modules/playlist/slice';
import renderCache from './modules/renderer/slice';
import resources from './modules/resources/slice';
import settings from './modules/settings/slice';
import sync from './modules/sync/slice';
import themes from './modules/themes/slice';
import ui from './modules/ui/slice';
import { youversion } from './modules/bible/youversion';
import { api } from './modules/account/api';

const rememberedKeys = [
  'account',
  'auth',
  'bible',
  'settings',
  'sync',
  'ui'
];

const reducer = rememberReducer({
  [api.reducerPath]: api.reducer,
  auth,
  bible,
  bootstrapper,
  output,
  playlist,
  renderCache,
  resources,
  settings,
  sync,
  themes,
  ui,
  [youversion.reducerPath]: youversion.reducer
});

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(listenerMiddleware.middleware)
      .concat(api.middleware)
      .concat(youversion.middleware),
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(
    rememberEnhancer(
      window.localStorage,
      rememberedKeys
    )
  ),
});

export type StoreType = typeof store
export type RootState = ReturnType<typeof reducer>
export type AppDispatch = StoreType['dispatch']

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
